<template>
  <div class="alarmAndOrderBox">
    <div class="left">
      <p>全部</p>
      <h6>{{tolNumber}}</h6>
    </div>
    <ul class="right">
      <li>
        <div class="content"
          v-for="(v, i) in rowList"
          :key="i">
          <img :src="require('@/assets/images/work/' + i + '.png')" />
          <div class="txtRight">
            <p>{{ v.name }}</p>
            <h6 :style="{ color: colorList[i] }">{{ v.value }}</h6>
          </div>
        </div>
      </li>
      <li>
        <div class="aotxtBox"
          v-for="(v,i) in row2List"
          :key="i">
          <p>{{v.name}}</p>
          <h6>{{v.value}}</h6>
        </div>
      </li>
      <li>
        <div class="aotxtBox"
          v-for="(v,i) in row3List"
          :key="i">
          <p>{{v.name}}</p>
          <h6>{{v.value}}</h6>
        </div>
      </li>
    </ul>
  </div>

</template>

<script>
import api from "@/api";
import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderSource,
  matchingOrderStatus,
} from "@/assets/js/utils";
export default {
  props: {
    comType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rowList: [],
      row2List: [],
      row3List: [],
      tolNumber: null,
      colorList: ["#8A88FF", "#FF9400", "#EC5453"],
    };
  },
  methods: {
    async getAlarmData() {
      this.rowList = [
        { name: "警告", value: null, key: "MINOR" },
        { name: "危险", value: null, key: "MAJOR" },
        { name: "高危", value: null, key: "CRITICAL" },
      ];
      this.row2List = [
        { name: "未确认", value: null, key: "notConfirmed" },
        { name: "已确认", value: null, key: "confirmed" },
      ];
      this.row3List = [
        { name: "未转工单", value: null, key: "notToRepair" },
        { name: "已转工单", value: null, key: "toRepaired" },
      ];
      let res = await api.getSAlarmAnalysis({
        type: "DAY",
        data: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        let objData = res.data.data;
        this.tolNumber = objData.overview.find((v) => {
          return v.name == "报警总数";
        }).value;
        this.rowList.map((v) => {
          v.value = objData.alarmLevelAnalysis.find((item) => {
            return item.name == v.key;
          }).value;
        });
        this.row2List.map((v) => {
          v.value = objData.confirmationStatusAnalysis.find((item) => {
            return item.name == v.key;
          }).value;
        });
        this.row3List.map((v) => {
          v.value = objData.toRepairAnalysis.find((item) => {
            return item.name == v.key;
          }).value;
        });
      }
    },
    async getOverview() {
      this.rowList = [];
      let res = await api.logisticsWOANALOverview({
        type: "DAY",
        date: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        this.tolNumber = res.data.data.num;
        this.rowList = Array.from(res.data.data.charts).map((item) => ({
          name: matchingOrderLevel(item.name),
          value: item.value,
        }));
      }
    },
    async getSource() {
      this.row2List = [];
      let res = await api.logisticsWOANALSource({
        type: "DAY",
        date: dateFtt("yyyy-MM-dd", new Date()),
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.row2List = Array.from(res.data.data).map((item) => ({
          name: matchingOrderSource(item.name),
          value: item.value,
        }));
      }
    },
    async getStatus() {
      this.row3List = [];
      let res = await api.logisticsWOANALStatus({
        type: "DAY",
        date: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        this.row3List = Array.from(res.data.data).map((item) => ({
          name: matchingOrderStatus(item.name),
          value: item.value,
        }));
      }
    },
  },
  created() {
    if (this.comType == "alarm") {
      this.getAlarmData();
    } else if (this.comType == "order") {
      this.getOverview();
      this.getSource();
      this.getStatus();
    }
  },
};
</script>

<style lang="scss" scoped>
.alarmAndOrderBox {
  width: 92%;
  height: 96%;
  margin: 2% auto;
  border: 1px solid #e3e3e3;
  @include setFlexBetween;
  .left {
    width: 20%;
    height: 100%;
    background: #f5faff;
    border-right: 1px solid #e3e3e3;
    @include setFlexColumn;
    align-items: center;
    justify-content: center;
    p {
      color: #333;
      font-size: 16px;
    }
    h6 {
      font-size: 26px;
      color: #097fff;
      margin-top: 5px;
    }
  }
  .right {
    width: calc(80% - 5px);
    height: 100%;
    margin: 0;
    @include setFlexColumn;
    li {
      width: 100%;
      height: 33%;
      border-bottom: 1px solid #e3e3e3;
      @include setFlexAround;
      .content {
        @include setFlexStart;
        img {
          margin-right: 10px;
        }
        .txtRight {
          p {
            color: #999;
          }
          h6 {
            font-size: 20px;
          }
        }
      }
    }
    li:last-child {
      border: none;
    }
  }
  .aotxtBox {
    text-align: center;
    p {
      color: #666;
    }
    h6 {
      color: #333;
      font-size: 20px;
    }
  }
}
</style>